import { PropTypes } from 'prop-types';
import React from 'react';

import ArrowLinkAngled from '../../../assets/svg/arrow-link-angled.svg';
import Link from '../../Link';

const CardTextBasedMedium = ({ author, link, title }) => {
  const url = link?.url || '/';
  return (
    <Link
      className="lg:pl-4 pl-2 lg:border-l-[6px] border-l-4 block text-hover"
      to={url}
    >
      <h3 className="stink-h3">{title}</h3>
      <p className="inline-flex mt-2 uppercase stink-eyebrow lg:mt-6">
        <span>{author}</span>
        <ArrowLinkAngled className="w-3 ml-1.5 h-full" />
      </p>
    </Link>
  );
};

CardTextBasedMedium.propTypes = {
  author: PropTypes.string,
  link: PropTypes.object,
  title: PropTypes.string,
};

export default CardTextBasedMedium;
